var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestDesignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9458_59497",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.5,
    height: 46.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9458_59497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5739 20.408L36.1701 13.6909L34.9783 12.4827L29.5739 17.9615L26.8478 15.2162L25.656 16.4545L29.5739 20.408ZM7 39V36.0909H29V39H7ZM30.9159 25.4242C28.4025 25.4242 26.2592 24.5263 24.4862 22.7304C22.7128 20.9345 21.8261 18.7627 21.8261 16.215C21.8261 13.667 22.7118 11.4942 24.4833 9.69673C26.2548 7.89891 28.3971 7 30.9102 7C33.4236 7 35.5668 7.89794 37.3399 9.69382C39.1133 11.4897 40 13.6615 40 16.2092C40 18.7573 39.1143 20.93 37.3428 22.7275C35.5713 24.5253 33.429 25.4242 30.9159 25.4242ZM7 23.4848V20.5758H18.1693C18.3434 21.113 18.5401 21.6208 18.7595 22.0992C18.9792 22.5779 19.2411 23.0398 19.5453 23.4848H7ZM7 31.2424V28.3333H24.854C25.477 28.674 26.1355 28.9636 26.8297 29.2022C27.5238 29.4411 28.2472 29.6127 29 29.7171V31.2424H7Z",
    fill: "#9747FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestDesignIcon);
export default __webpack_public_path__ + "static/media/testDesignIcon.6c2623dc7e9ce468173fc7d0fddf0353.svg";
export { ForwardRef as ReactComponent };